import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Inject, LOCALE_ID } from '@angular/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(this.locale)
    {
      const modifiedRequest = request.clone({ setHeaders: {
        'lang': this.locale,
        'returnAllLanguages': 'false'
      } });
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}
